import { TextField } from "@mui/material";
import { Controller, Control } from "react-hook-form";
import { createUseStyles } from "react-jss";
import { theme } from "$utils/theme/bataillog";
import { Text } from "$components";

export type CFieldInputProps = {
  required?: boolean;
  label?: string;
  error?: boolean;
  onChange: (val: any) => void;
  value: any;
  placeholder?: string;
  control: Control<any, any>;
  style: any;
};

function CField({
  children,
  error,
  name,
  rules,
  disabled,
  label,
  required,
  placeholder,
  style = {},
  control,
  ...props
}: any) {
  const classes = useStyles();

  const crules = rules ? { ...rules } : {};
  if (required && !crules.required) {
    crules.required = "Veuillez remplir ce champ";
  }

  const labelText = required && label ? `${label} *` : label;

  return (
    <Controller
      control={control}
      name={name}
      rules={crules}
      render={({ field }) => {
        let Input;
        if (children) {
          Input = children({
            ...field,
            ...props,
            required,
            disabled,
            label: labelText,
            error: Boolean(error),
          });
        } else {
          Input = (
            <TextField
              label={labelText}
              disabled={disabled}
              {...field}
              error={Boolean(error)}
              variant="outlined"
              style={{ width: "100%" }}
              placeholder={placeholder}
              InputLabelProps={{ shrink: Boolean(field.value) }}
              {...props}
            />
          );
        }

        return (
          <div style={{ flex: 1, ...style }} className={classes.wrapper}>
            {Input}
            {error && error.message ? (
              <Text className={classes.errorField}>
                {error.message.toString()}
              </Text>
            ) : null}
          </div>
        );
      }}
    />
  );
}

const useStyles = createUseStyles(() => ({
  wrapper: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    gap: theme.spacing(1),
  },
  errorField: {
    minHeight: 20,
    color: theme.color.red,
    fontSize: 12,
  },
}));

export default CField;
